/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/prop-types */
import React from 'react';
import { GoogleLogin } from 'react-google-login';
import Cookies from 'js-cookie';
import loginGoogle from '@assets/images/social-media-icons/google.png';
import { userLoggedIn, ssoLogin, socialMediaLogin } from '@features/Authentication/services/authenticationApi';
import setSegmentIdentity from '@shared/utils/SetSegmentIdentity';
import unsetSegmentIdentity from '@shared/utils/UnsetSegmentIdentity';

function LoginViaGoogle({
  modalFunc,
  loggedInFunc,
  _setSubLabelText,
  ...props
}) {
  function userProfile(userToken) {
    userLoggedIn(userToken)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.code === '200') {
            modalFunc({
              modalStatus: false,
            });
            loggedInFunc({
              loggedIn: response.data.data,
              modalStatus: false,
            });
            Cookies.set('uid', response.data.data.user_id, { expires: 90, secure: true });
            // segment tracking
            if (process.env.REACT_APP_ON_SEGMENT === 'true') {
              // segment set identify call
              if (response.data.data.guid) {
                setSegmentIdentity(response.data.data.guid);
              // segment unset identify call
              } else {
                unsetSegmentIdentity();
              }
              // login success segment event
              window.analytics.track('Login Succeeded', {
                login_method: 'Google',
              });
            }
          }
        }
      });
  }

  const responseGoogle = (response) => {
    const dataGoogle = new URLSearchParams({
      oauth_provider: 'google',
      oauth_id: response.googleId,
    });
    socialMediaLogin(dataGoogle)
      .then(async (socRes) => {
        if (socRes.data.status === 'error') {
          props.googleError();
        } else {
          const ssoData = new URLSearchParams({
            username: socRes.data.data.user_guid,
            otp: socRes.data.data.otp,
          });
          await ssoLogin(ssoData)
            .then(async (ssoRes) => {
              if (ssoRes.data.code === '200') {
                Cookies.set('token', ssoRes.data.data.access_token, { expires: 90, secure: true });
                const userToken = ssoRes.data.data.access_token;
                userProfile(userToken);
              } else {
                // login failed segment event
                window.analytics.track('Login Failed', {
                  login_method: 'Google',
                  error_message: ssoRes.data.data.error_description
                    ? ssoRes.data.data.error_description
                    : ssoRes.data.message,
                });
              }
            }).catch((error) => {
              console.error(error);
              // login failed segment event
              window.analytics.track('Login Failed', {
                login_method: 'Google',
                error_message: error,
              });
            });
        }
      });
  };

  function googleAgree(onClick) {
    onClick();
    props.loginViaGoogle();
  }
  return (
    <div>
      <GoogleLogin
        clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
        onSuccess={responseGoogle}
        cookiePolicy='single_host_origin'
        render={(renderProps) => (
          // eslint-disable-next-line jsx-a11y/no-static-element-interactions
          <div className='login-options js-btn-step' data-toggle='tooltip' title='Login via Google' onClick={() => googleAgree(renderProps.onClick)}>
            <div className='google-button-container'>
              <img className='google-login' src={loginGoogle} alt='login-via-google' />
              <p>Continue with Google</p>
            </div>
          </div>
        )}
      />
    </div>
  );
}

export default LoginViaGoogle;
